export { ChartPie as default } from './ChartPie';
